import { importAuthUtils } from "../components/utils/auth";
import { apiBaseUrl } from "../components/utils/getConfigs";

export const userFraudInfo = async () => {
  try {
    if(!(globalThis.PSX_AUTH && globalThis.PSX_AUTH.getCognitoIdToken)){
      await importAuthUtils();
    }

    const token = await globalThis.PSX_AUTH.getCognitoIdToken();
    let userFraudApiUrl = `${apiBaseUrl}/api/psx-user/me/fraud-information`;
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    };

    const retrieveUserFraudData = await fetch(userFraudApiUrl, {
      method: 'GET',
      headers
    });
    const userFraudData = await retrieveUserFraudData.json();

    return userFraudData;
  } catch (e) {
    console.error('Failed to retrieve user fraud data:', e);
  }
}

export const userFraudInfoEnhanced = async () => {
  let userFraudEnhancedApiUrl = `${apiBaseUrl}/api/psx-user/me/enhanced-fraud-information`;
  try {
    if(!(globalThis.PSX_AUTH && globalThis.PSX_AUTH.getCognitoIdToken)){
      await importAuthUtils();
    }
    const token = await globalThis.PSX_AUTH.getCognitoIdToken();
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    };

    const retrieveUserFraudData = await fetch(userFraudEnhancedApiUrl, {
      method: 'GET',
      headers
    });

    const userFraudData = await retrieveUserFraudData.json();

    return userFraudData;
  } catch (e) {
    console.error('Failed to retrieve user data:', e);
  }
}

export const isUserFraudulentEnhanced = async (actionType?: string) => {
  try {
    const userFraudData = await userFraudInfoEnhanced();
    const riskAssessmentLevel = userFraudData?.riskAssessment?.toLowerCase();
    const useActionType = actionType?.toLowerCase() === 'offer' || actionType?.toLowerCase() === 'test-drive';
    return useActionType ? riskAssessmentLevel === "high" : riskAssessmentLevel === "medium" && !userFraudData?.isVerified;
  } catch (e) {
    console.error('Failed to get user data:', e);
  }
}

export const isUserFraudulent = async (isUserVerified: boolean, actionType?: string) => {
  try {
    const userFraudData = await userFraudInfo();
    const riskAssessmentLevel = userFraudData?.risk_assessment_level?.toLowerCase();
    const useActionType = actionType?.toLowerCase() === 'offer' || actionType?.toLowerCase() === 'test-drive';
    if (useActionType) {
      return riskAssessmentLevel === "high";
    }

    return riskAssessmentLevel === "high" || (riskAssessmentLevel === "medium" && !isUserVerified);
  } catch (e) {
    console.error('Failed to get user data:', e);
  }
}
